<template>
  <div style="padding-top: .98rem">
    <topbar :hideBackBtn="true" text="申请列表"></topbar>
    <div class="itemBox">
      <div class="name">选择类型</div>
      <select v-model="type">
        <option v-for="t in types" :value="t.value">{{t.label}}</option>
      </select>
    </div>
    <div class="btn" @click="gotoApply">提交</div>
  </div>
</template>
<script>

import topbar from 'components/topbar'
import { applicationTypes } from '@/utils/enums'

export default {
  data() {
    return {
      type: ''
    }
  },
  components: { topbar },
  computed: {
    types() {
      console.log(applicationTypes())
     return  this.$utils.convertObj2Array(applicationTypes())
    }
  },
  created() {
  },
  methods: {
    gotoApply() {
      if (!this.type) {
        alert('请选择类型')
        return
      }
      this.$router.push(`/application?type=${this.type}`)
    }
  },
}
</script>
<style>
.itemBox {
  margin-top: .16rem;
  height: .88rem;
  padding: 0 .24rem;
  display: flex;
  align-items: center;
  background: #fff;
}

.name {
  width: 1.2rem;
  font-size: .3rem;
  color: #212121;
  margin-right: .7rem;
}

select {
  border: none;
  font-size: .3rem;
  color: #212121;
}

.btn {
  width: 7.02rem;
  height: .8rem;
  border-radius: .1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: .3rem;
  color: #fff;
  margin: 1.5rem auto 0;
  background: #00C59F;
}
</style>



// WEBPACK FOOTER //
// src/components/application/list.vue